import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AdminProvider } from './context/AdminContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Stock from './pages/Stock';
import CarDetail from './pages/CarDetail';
import Import from './pages/Import';
import About from './pages/About';
import Contact from './pages/Contact';
import Admin from './pages/Admin';

function Layout({ children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <main style={{ flex: 1 }}>{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AdminProvider>
        <Routes>
          {/* Admin — no nav/footer */}
          <Route path="/admin" element={<Admin />} />

          {/* Public site */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/stock" element={<Layout><Stock /></Layout>} />
          <Route path="/car/:id" element={<Layout><CarDetail /></Layout>} />
          <Route path="/import" element={<Layout><Import /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AdminProvider>
    </BrowserRouter>
  );
}
